import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SemManyToOneControlComponent } from '../../sem-many-to-one-control/sem-many-to-one-control.component';
import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, OnInit, Inject, AfterViewInit } from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { RestProviderService } from '../../../../services/rest-provider/rest-provider.service';
import { SearchService } from 'src/app/services/search/search.service';
import { TranslationsProviderService } from 'src/app/services/translations-provider/translations-provider.service';


/**
 * Food data with nested structure.
 * Each node has a name and an optional list of children.
 */
interface HierarchyObject {
  name: string;
  id?: Number;
  parentId?: Number;
  children?: HierarchyObject[];
  dirty: boolean;
  // false = node above the lowest allowed level; clicking only expands it
  selectable: boolean;
}

/**
 * @title Tree with nested nodes
 */
@Component({
    selector: 'app-sem-treeview-dialog',
    templateUrl: './sem-treeview-dialog.component.html',
    styleUrls: ['./sem-treeview-dialog.component.css'],
    standalone: false
})
export class SemTreeviewDialogComponent implements OnInit, AfterViewInit {

  treeControl = new NestedTreeControl<HierarchyObject>(node => node.children);
  dataSource = new MatTreeNestedDataSource<HierarchyObject>();

  entityModel: string;
  propName: string;
  linkWithExistingData: string;
  title: string;
  flatTreeData: HierarchyObject[] = [];
  treeData: HierarchyObject[] = [];

  loading: boolean = false;

  // backend denies and return 500 api response if search is FieldName:* + FieldValue:*
  defaultSearchQueryString: string = "{\"MainQuery\":null,\"FieldQueries\":{},\"FacetQueries\": {},\"RequestedFacets\": null,\"Projection\": [],\"TreeQuery\": { \"Type\": \"FieldRange\", \"FieldName\": \"Id\", \"FieldValueFrom\": 1, \"FieldValueTo\": \"*\" },\"ClassTypes\": [],\"Page\": \"1\",\"PageSize\": \"1000\",\"RepositoryName\": \"lucene\",\"Form\": null,\"UseCache\": false, \"IncludeParents\": false}";
  mainSearchQuery: any;

  models: any[] = [];
  selectedPage: number;

  searchTerm: string = "";

  // The registry is fetched once and kept, so typing filters the cached list instead of
  // asking the server again on every keystroke.
  private allModels: any[] = null;
  private searchDebounce: any = null;

  private searchServiceSubscriber: any = null;

  constructor(public dialogRef: MatDialogRef<SemManyToOneControlComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private restProvider: RestProviderService,
    public searchService: SearchService,
    public translationsService: TranslationsProviderService) {

  }

  hasChild = (_: number, node: HierarchyObject) => !!node.children && node.children.length > 0;

  /** Tooltip on nodes that only expand. Falls back to Slovene when the module has no translation. */
  get notSelectableHint(): string {
    let key = "WebGalis_Module_WAM_TreeNodeNotSelectable";
    let text = this.translationsService.translations ? this.translationsService.translations[key] : null;
    return text ? text : "Izberite postavko na nižji ravni.";
  }



  ngOnDestroy(): void {
    if (typeof this.searchServiceSubscriber != "undefined" && this.searchServiceSubscriber != null) {
      this.searchServiceSubscriber.unsubscribe();
    }
  }

  ngOnInit() {

    this.mainSearchQuery = JSON.parse(this.defaultSearchQueryString);

    // based on display fields set projection on query
    if (this.mainSearchQuery != null && typeof this.mainSearchQuery != "undefined") {

      let displayFieldsForProjection = [];

      /*for (var i = 0; i < this.displayFields.length; i++) {
        displayFieldsForProjection.push(this.displayFields[i].PropertyName);
      }*/

      this.mainSearchQuery["Projection"] = Object.assign([], displayFieldsForProjection);
      // always add "Id" to projection
      this.mainSearchQuery.Projection.push("Id");
      this.mainSearchQuery.Projection.push("SourceRepository");
      this.mainSearchQuery.Projection.push("RepositoryId");
      this.mainSearchQuery.Projection.push("Parent.Id");
      this.mainSearchQuery.Projection.push("Title");
    }

    this.linkWithExistingData = this.translationsService.translations["WebGalis_LinkWithExistingData"];
    this.entityModel = this.dialogData["entityModel"];
    this.propName = this.dialogData["propName"];

  }

  ngAfterViewInit() {
    this.mainSearchQuery["ClassTypes"].push(this.entityModel);
    this.performDataSearch(1, null);
  }

  closeDialog() {
    this.dialogRef.close();
  }

  onEnter() {
    this.runSearch();
  }

  /**
   * Filters while the user types. Until now the tree only reacted to Enter, with nothing
   * on screen saying so - typing looked like the search was broken.
   */
  onSearchChanged() {
    if (this.searchDebounce != null) {
      clearTimeout(this.searchDebounce);
    }

    this.searchDebounce = setTimeout(() => {
      this.searchDebounce = null;
      this.runSearch();
    }, 250);
  }

  private runSearch() {
    if (this.searchDebounce != null) {
      clearTimeout(this.searchDebounce);
      this.searchDebounce = null;
    }

    let term = this.searchTerm != null && this.searchTerm.length > 0 ? this.searchTerm : null;
    this.performDataSearch(1, term);
  }

  /**
   * Filters the already fetched registry by title, case insensitive, and rebuilds the tree.
   * Runs entirely on the client - the list is fetched once when the dialog opens.
   */
  private applyLocalFilter(searchString) {

    this.models = this.allModels != null ? this.allModels.slice() : [];

    if (this.models.length == 0) {
      this.loading = false;
      return;
    }

    if (searchString && searchString.length > 0) {
      let term = searchString.toLowerCase();

      if (typeof this.models[0].Value != "undefined") {
        this.models = this.models.filter(az => az.Value.Title != null && az.Value.Title.toLowerCase().indexOf(term) > -1);

        this.models.sort((a, b) => {
          if (a.Value.Title < b.Value.Title) { return -1; }
          if (a.Value.Title > b.Value.Title) { return 1; }
          return 0;
        });
      } else {
        this.models = this.models.filter(az => az.Title != null && az.Title.toLowerCase().indexOf(term) > -1);

        this.models.sort((a, b) => {
          if (a.Title < b.Title) { return -1; }
          if (a.Title > b.Title) { return 1; }
          return 0;
        });
      }
    }

    this.loadData(searchString);
  }

  performDataSearch(page, searchString) {

    this.models = [];
    this.treeData = [];
    this.flatTreeData = [];

    this.loading = true;

    if (this.dialogData["customApiUrl"]) {

      if (this.allModels != null) {
        this.applyLocalFilter(searchString);
        return;
      }

      this.restProvider.getDataGET(this.dialogData["customApiUrl"] + "/" + this.dialogData["entityModel"]).subscribe((data: any) => {
        this.allModels = JSON.parse(data);
        this.applyLocalFilter(searchString);
      }, error => {
        this.loading = false;
      });

    } else {

      this.flatTreeData = [];
      this.selectedPage = page;
      this.models = [];
      this.loading = true;
      this.mainSearchQuery.IncludeParents = true;

      // The backend resolves FieldName "*" only in a FieldValue query, so each case sends a complete TreeQuery:
      // no search = every record (FieldRange on Id), search = Title prefix (FieldValue).
      if (searchString != null) {
        this.mainSearchQuery.TreeQuery = {
          Type: "FieldValue",
          FieldName: "Title",
          FieldValue: searchString.includes("*") ? searchString : searchString + "*"
        };
      }
      else {
        this.mainSearchQuery.TreeQuery = { Type: "FieldRange", FieldName: "Id", FieldValueFrom: 1, FieldValueTo: "*" };
      }

      this.searchServiceSubscriber = this.searchService.performSearch(this.mainSearchQuery, null, null, null).subscribe(data => {


        for (var i = 0; i < data["Models"].length; i++) {
          this.models.push(data["Models"][i]["Model"]);
        }

        this.loadData(searchString);

      }, error => {
        //console.log(error);
        this.loading = false;
      });
    }
  }

  loadData(searchString) {

    this.models.forEach(element => {
      var a = {} as HierarchyObject;
      if (typeof element.Value != "undefined") {
        a.name = element.Value.Title;
        a.id = element.Value.Id;
      } else {
        a.name = element.Title;
        a.id = element.Id;
      }

      //(foo === null || foo === undefined)
      if (element.Parent != undefined || element.Parent != null) {

        a.parentId = element.Parent.Id;
      }
      a.dirty = false;
      a.selectable = element.Selectable !== false;

      this.flatTreeData.push(a);

    });

    this.flatTreeData.forEach(elItem => {
      let filteredArr = this.flatTreeData.filter(filt => filt.parentId == elItem.id);
      elItem.children = filteredArr;
      if (searchString != null) {
        this.markDirty(filteredArr);
      }
    })

    let filteredRoots: HierarchyObject[] = this.flatTreeData.filter(ft => ft.parentId == null || ft.parentId == undefined)

    /*filteredRoots.forEach(elementRoot => {
      
      let childs: HierarchyObject[] = this.flatTreeData.filter(ft => ft.parentId == elementRoot.id);
      if(childs != null && childs != undefined){
        elementRoot.children = childs;
      }

      this.treeData.push(elementRoot);
    });*/
    if (filteredRoots.length > 0) {
      this.treeData = filteredRoots;
    }
    else {
      this.treeData = this.flatTreeData.filter(az => az.dirty == false);
    }

    this.treeData.sort((a, b)=>{
      if(a.name < b.name) { return -1; }
      if(a.name > b.name) { return 1; }
      return 0;
  });

    this.dataSource.data = this.treeData;
    this.treeControl.dataNodes = this.treeData;
    this.loading = false;
    this.treeControl.collapseAll();
  }

  markDirty(filteredTreeArray: HierarchyObject[]) {
    filteredTreeArray.forEach(element => {
      var a = this.flatTreeData.filter(ft => ft.id == element.id)[0];
      if (a != undefined) {
        a.dirty = true;
      }
    });
  }


  linkClicked(data) {
    // The server marks codelist items above the lowest allowed level (e.g. loss event type
    // below level 3) as not selectable - picking one would only fail later on save.
    if (data.selectable === false) {
      this.treeControl.toggle(data);
      return;
    }

    this.loading = true;

    var url = "";

    if (data.id > 0 || data.id != undefined) {
      url = "api/data/relatedentity/" + this.dialogData["formName"] + "/" + this.propName + "/" + this.entityModel + "/" + data.id;
    } else {
      //relatedentity/external/{formInfo}/{propName}/{sourcerepository}/{repositoryid}
      url = "api/data/relatedentity/external/" + this.dialogData["formName"] + "/" + this.dialogData["propName"] + "/" + data["SourceRepository"] + "/" + data["RepositoryId"];
    }

    this.restProvider.getDataGET(url).subscribe(data => {
      let jsonData = JSON.parse(data);
      this.dialogRef.close(jsonData["Model"]);

      this.loading = false;
    }, error => { this.loading = false; });

  }

  searchString() {
    alert("Search Fired!");
  }

}
